import { Col, Image, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const MethodDetails = ({ MethodDetails }, props): ReactElement => {
  const [getMethodDetails, setMethodDetails] = useState(undefined);

  useEffect(() => {
    setMethodDetails(MethodDetails);
  }, [MethodDetails]);

  return (
    <React.Fragment>
      <div className="user-deatils-area">
        <Tab.Container id="left-tabs-example" defaultActiveKey="basic">
          <Row gutter={5}>
            <Col span={24}>
              <div className="user-detals-wrapper-content">
                <div className="user-details-inner-content_">
                  <div className="user-image-content">
                    <div className="">
                      <Image src={getMethodDetails?.logo} className="rounded" />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col span={24} style={{ background: "#fff" }}>
              <div className="inner-body">
                <div className="single">
                  <div className="info-name">
                    <span>Payment Method</span>
                  </div>
                  <div className="info-desc">
                    <span>{getMethodDetails?.name}</span>
                  </div>
                </div>

                {getMethodDetails?.title ? (
                  <div className="single">
                    <div className="info-name">
                      <span>Title</span>
                    </div>
                    <div className="info-desc">
                      <span>{getMethodDetails?.title}</span>
                    </div>
                  </div>
                ) : undefined}

                <div className="single">
                  <div className="info-name">
                    <span>Method ID</span>
                  </div>

                  <div className="info-desc">
                    <span>{getMethodDetails?.id}</span>
                  </div>
                </div>

                <div className="single">
                  <div className="info-name">
                    <span>Type</span>
                  </div>
                  <div className="info-desc">
                    <span>{getMethodDetails?.type?.replace("_", " ")}</span>
                  </div>
                </div>

                {getMethodDetails?.status ? (
                  <div className="single">
                    <div className="info-name">
                      <span>Status</span>
                    </div>
                    <div className="info-desc">
                      <span>{getMethodDetails?.status}</span>
                    </div>
                  </div>
                ) : undefined}

                {getMethodDetails?.description ? (
                  <div className="single">
                    <div className="info-name">
                      <span>Description</span>
                    </div>
                    <div className="info-desc">
                      <span>{getMethodDetails?.description}</span>
                    </div>
                  </div>
                ) : undefined}
              </div>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </React.Fragment>
  );
};
MethodDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default MethodDetails;
